export const MANAGE_VIEW_ACTIONS = {
  SET_SPINNER_VIEW: 'view/setSpinnerView',
  SET_SELECTED_CUSTOM_VIEW: 'view/setSelectedCustomViewFolder',
  SET_SELECTED_CUSTOM_VIEW_FOLDER_NAME: 'view/setSelectedCustomViewFolderName',
  UPDATE_QUERY_GROUPS: 'view/updateQueryGroups',
  UPDATE_QUERY_DISPLAY_COLUMNS: 'view/updateQueryDisplayColumns',
  UPDATE_FAV_VIEW_BY_ID: 'view/updateFavViewById',
  UPDATE_DEFAULT_VIEW_BY_ID: 'view/updateDefaultViewById',
  ADD_SHARED_VIEW_BY_TENANT: 'view/addSharedViewByTenant',
  UPDATE_MESSAGE_BAR: 'messageBar/updateMessageBar',
  UPDATE_USER_PROFILE: 'user/updateUserProfile',
  SET_USER_RATING_DATE: 'userRating/setUserRatingData',
  SET_SHOW_RATING_IN_CENTER: 'userRating/setShowRattingInCenter',
  SET_RATING_CONFIG: 'userRating/setRatingConfig',
  UPDATE_MESSAGE_BAR_SUCCESS_STATE: 'messageBar/updateMessageBarSuccessState',
  UPDATE_MESSAGE_BAR_ERROR_STATE: 'messageBar/updateMessageBarErrorState',
  UPDATE_MESSAGE_BAR_INFO_STATE: 'messageBar/updateMessageBarInfoState',
  EDIT_ON_CLICK: 'view/editOnClick',
  UPDATE_FOCUSED_PARENT_FOLDER: 'view/updateFocusedParentFolder',
  SET_SELECTED_FILTER_QUERY_VALIDATION: 'view/setSelectedFilterQueryValidation',
  UPDATE_QUERY_GROUP_INFO: 'view/updateQueryGroupInfo',
  SET_ACTIONS_COUNT: 'view/setActionsCount',
  VIEW_ON_CHANGE: 'view/viewOnChange',
  SET_SKIP_INDEX: 'view/manageViewSetSkipIndex',
  UPDATE_FETCH_SHOULD_CALL: 'view/updateFetchShouldCall',
  CLEAR_PREVIEW_GRID_ITEMS: 'view/clearPreviewGridItems',
  UPDATE_SHOULDCALL_CHECK_ADD_USER: 'view/updateShouldCallCheckAndAddUserToView',
};
